<div *ngIf="isShow && !!message" [ngClass]="status" class="notification w-100">
  <svg-icon [key]="getIcon()" class="flex-shrink-0"></svg-icon>
  <div class="body translate">{{ message }}</div>
  <a (click)="hide()" role="button" data-test="notification-close">
    <svg-icon key="greyClose"></svg-icon>
  </a>
</div>
